import { AttributeSet, Variant, VariantAttributeValue } from '@mediashop/app/api/types/ClientProduct';

const getInitialSelectedDimensions = (
    variantCombinations: Record<string, string[]>,
    variants: Variant[],
    selectedVariant?: Variant
) => {
    let initialSelectedCombinations: AttributeSet | Record<string, VariantAttributeValue>;

    if (selectedVariant) {
        initialSelectedCombinations = selectedVariant?.attributes;
    } else {
        const dealVariants = variants.filter((value) => value.price.priceType === 'DEAL');

        if (!dealVariants.length) {
            initialSelectedCombinations = variants[0]?.attributes;
        } else if (dealVariants.length === 1) {
            initialSelectedCombinations = dealVariants[0]?.attributes;
        } else if (dealVariants.length > 1) {
            const sortedDealVariants = dealVariants.sort(
                (aVariant, bVariant) => aVariant.price.centAmount - bVariant.price.centAmount
            );
            initialSelectedCombinations = sortedDealVariants[0]?.attributes;
        }
    }
    return Object.keys(variantCombinations).reduce(
        (selectedCombinations, dimension) => ({
            ...selectedCombinations,
            [dimension]: initialSelectedCombinations?.[dimension],
        }),
        {}
    );
};

export default getInitialSelectedDimensions;
